import Box from '@mui/material/Box'
import { node, number, shape, string } from 'prop-types'
import { forwardRef } from 'react'
import Typography from '../../atoms/typography'
import Rating from '../rating'
import { Avatar } from './card-rating.styled'
import CardText from './card-text'

const CardRating = forwardRef(
	(
		{
			emptyStarIcon,
			starIcon,
			ratingValue,
			image,
			imageAlt,
			imageWidth,
			imageHeight,
			imageText,
			imageTextProps,
			...props
		},
		ref
	) => {
		return (
			<CardText
				ref={ref}
				{...props}
				header={
					<div style={{ padding: '32px 32px 0' }}>
						<Rating emptyIcon={emptyStarIcon} icon={starIcon} value={ratingValue} readOnly />
						<Box display="flex" alignItems="center" mt="24px">
							{image && <Avatar alt={imageAlt} src={image} sx={{ height: imageHeight, width: imageWidth }} />}
							{imageText && (
								<Typography variant="h6" {...imageTextProps}>
									{imageText}
								</Typography>
							)}
						</Box>
					</div>
				}
			/>
		)
	}
)

CardRating.displayName = 'CardRating'

CardRating.defaultProps = { ...CardText.defaultProps }

CardRating.propTypes = {
	...CardText.propTypes,
	emptyStarIcon: node,
	starIcon: node,
	ratingValue: number.isRequired,
	image: string,
	imageAlt: string,
	imageWidth: number,
	imageHeight: number,
	ImageText: node,
	imageTextProps: shape(Typography.propTypes),
}

export default CardRating
